var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgITrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27,7H5c-.55,0-1,.45-1,1s.45,1,1,1h22c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12,14v8c0,.55.45,1,1,1s1-.45,1-1v-8c0-.55-.45-1-1-1s-1,.45-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18,14v8c0,.55.45,1,1,1s1-.45,1-1v-8c0-.55-.45-1-1-1s-1,.45-1,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8,27V8c0-.55-.45-1-1-1s-1,.45-1,1v19c0,.83.59,1.41.59,1.41.59.59,1.41.59,1.41.59h16c.83,0,1.41-.59,1.41-.59.59-.59.59-1.41.59-1.41V8c0-.55-.45-1-1-1s-1,.45-1,1v19H8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.88,3.88c-.88.88-.88,2.12-.88,2.12v2c0,.55.45,1,1,1s1-.45,1-1v-2c0-.41.29-.71.29-.71.29-.29.71-.29.71-.29h6c.41,0,.71.29.71.29.29.29.29.71.29.71v2c0,.55.45,1,1,1s1-.45,1-1v-2c0-1.24-.88-2.12-.88-2.12-.88-.88-2.12-.88-2.12-.88h-6c-1.24,0-2.12.88-2.12.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITrash);
export default __webpack_public_path__ + "static/media/i_trash.c41ac12de44fbf46481a6adb9b27bd92.svg";
export { ForwardRef as ReactComponent };